/**
 * Created by lu on 2018/2/1.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    parent:nb.model.List,
    method:{
        init:function () {
            this.set('itemType',require('../view/SeriesList').SeriesItem);
            this.set('itemModelType',require('./SeriesListItem'));

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/SeriesList.js
// module id = 172
// module chunks = 1 4